import { useCallback } from 'react'

import { config } from 'app/config'

import { httpCall } from './httpUtils'

const apiPath = '/api'

const useHttp = () => {
  const httpPost = useCallback(
    <T, R, E>(endpoint: string, data: T, contentType = 'application/json') =>
      httpCall<T, R, E>(
        `${config.innkeeprBaseApiUrl}${apiPath}${endpoint}`,
        'POST',
        contentType,
        data,
      ),
    [],
  )

  return {
    httpPost,
  }
}

export default useHttp
